import sortBy from 'lodash/sortBy';
import { createSelector } from 'reselect';

export const getFeeds = (state) => state?.feed?.feeds;

export const selectFeeds = createSelector(getFeeds, (feeds) => {
  return sortBy(feeds, 'name');
});
